const { REACT_APP_STAGE } = process.env;

// These paths are used when the relevant links are rendered for WLs
const WL_HOST_PATHS = {
  INT: 'int.health.io-comms.com',
  ACC: 'acc.health.io-comms.com',
  PROD: 'health.io-comms.com',
};

// These paths are used when the relevant links are rendered for NON WLs
const FLEXIO_HOST_PATHS = {
  INT: 'int.start.flexio.energy',
  ACC: 'acc.start.flexio.energy',
  PROD: 'start.flexio.energy',
};

export type ENVIRON = 'INT' | 'ACC' | 'PROD';

function getHostEnvironment() {
  if (REACT_APP_STAGE === 'dev') {
    return 'ACC';
  }

  if (REACT_APP_STAGE === 'v1') {
    return 'PROD';
  }

  return 'INT';
}

export function getFlutterWebHostPath(isWL: boolean): string {
  const env: ENVIRON = getHostEnvironment();
  const paths = isWL ? WL_HOST_PATHS : FLEXIO_HOST_PATHS;

  return `https://${paths[env]}`;
}
